import React from 'react';
import { StepItem } from '../../../../../../components/Step';
import { Container, Ul, LI, StepCopy, StepContentWrapper, Subtitle, Title, Left, LeftContent, Right, TitleESSPrice } from './styles';
import { formattedDollar, formattedNumber } from '../../../../../../utils/formatterHelpers';

const BatteryUses = ({ terms }) => (
    <Container>
        <Left>
            <LeftContent>
                <Title>Reinvest Your Solar Savings</Title>
                {terms.showLoan && terms.loanProvider === 'mosaic' ?
                    <Subtitle>
                        <LI>
                            Mosaic Savings: ${formattedNumber(terms.annualResults[30].cumulativeMosaicSavings)}
                        </LI>
                    </Subtitle>
                    : null }
                {terms.showCAP ?
                    <Subtitle>
                        <LI>
                            Capital Lease Savings: ${formattedNumber(terms.annualResults[30].cumulativeCAPSavings)}
                        </LI>
                    </Subtitle>
                    : null }
                {terms.showLoan && terms.loanProvider === 'custom' ?
                    <Subtitle>
                        <LI>
                            Loan Savings: ${formattedNumber(terms.annualResults[30].cumulativeLoanSavings)}
                        </LI>
                    </Subtitle>
                    : null }
                <Subtitle>
                    <LI>
                        Cash Savings: ${formattedNumber(terms.annualResults[30].cumulativeCashSavings)}
                    </LI>
                </Subtitle>
            </LeftContent>
        </Left>

        <Right>
            <Ul>
                {terms.showLoan && terms.loanProvider === 'mosaic' ?
                    <StepItem
                        title={terms.loanName}
                    >
                        <StepContentWrapper>
                            <StepCopy>
                                <TitleESSPrice>
                                    {terms.mosaicAdderText}
                                </TitleESSPrice>
                                <Subtitle>
                                    <LI>
                                        Battery Adder: ${formattedDollar(terms
                                            .essPrice * terms.mosaicFee)}
                                    </LI>
                                    <LI>
                                        ESS ITC: ${formattedDollar(-1 * ((terms.essPrice * terms.mosaicFee) * 0.26))}
                                    </LI>
                                    <LI>
                                        Net Price: ${formattedDollar(((terms.essPrice * terms.mosaicFee) * 0.74))}
                                    </LI>
                                    {terms.projectState === 2 &&
                                        <LI>
                                            SMART ESS Adder: ${formattedNumber(0.046 * terms.annualResults[1].systemProduction * terms.smartTerm / terms.mosaicTerm)}/monthly average per loan term
                                        </LI> }
                                </Subtitle>
                            </StepCopy>
                        </StepContentWrapper>
                    </StepItem>
                    : null }
                <StepItem
                    title="Cash Adder"
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <TitleESSPrice>Net Price  ${formattedDollar(terms.essPriceNetITC)}
                            </TitleESSPrice>
                            <Subtitle>
                                <LI>
                                    Battery Adder: {terms.essCashPrice}
                                </LI>
                                {terms.showLoan && terms.loanProvider === 'mosaic' &&
                                <LI>
                                    Cash Discount: ${formattedDollar(terms
                                        .essPrice * (1 - terms.mosaicFee))}
                                </LI>
                                }
                                <LI>
                                    ESS ITC: ${formattedDollar(-1 * (terms.essPrice - terms.essPriceNetITC))}
                                </LI>
                                {terms.projectState === 2 &&
                                    <LI>
                                        SMART ESS Adder: ${formattedNumber(0.046 * terms.annualResults[1].systemProduction )}/year
                                    </LI> }
                            </Subtitle>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

            </Ul>
        </Right>
    </Container>
);

export default BatteryUses;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/BatteryPrice/BatteryPrice.js